import { Button, Col, DatePicker, Form, Modal, Row, Space } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store';
import { getDrivingLicenseVerification, setDlVerified, setDobLoading, setDobModal, setSuccessModal } from '../../../../../../../store/actions/newAdmissionAction';
import { ApplicationDetailModel } from '../../../../../../../store/models/applicationDetailModel';
import { centeredNotification } from '../../../../../../../utils/utility';
import './VerifyIdentityModal.less';

const DobIdentityModal = ({
  form, drivingLicense }: any): ReactElement => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    newAdmission: { dlVerified },
  }: any = useSelector((state: RootState): RootState => state);
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const dispatch = useDispatch();

  useEffect((): any => {
    form?.resetFields(['dateOfBirthDrivingLicense']);
  }, [dlVerified]);

  const onDOBSuccessSubmit = (): void => {
    dispatch(setDobModal(false));
    dispatch(setSuccessModal(true));
    dispatch(setDlVerified(true));
  };

  const verifyDob = (): void => {
    setIsLoading(true);
    if (!form.getFieldsValue()?.dateOfBirthDrivingLicense) {
      centeredNotification('DOB is mandatory for Driving License');
      setIsLoading(false);
      return;
    }
    const payload = {
      providerId: appdetails.getProviderId(),
      documentType: 'DrivingLicense',
      docNumber: drivingLicense,
      DOB: form.getFieldsValue()?.dateOfBirthDrivingLicense.toISOString().split('T')[0] || null,
    };
    form?.setFieldsValue({ dateOfBirthDrivingLicense: form.getFieldsValue()?.dateOfBirthDrivingLicense });
    dispatch(getDrivingLicenseVerification(payload, onSuccess, onError));
  };

  const onSuccess = (): any => {
    setIsLoading(false);
    onDOBSuccessSubmit();
    dispatch(setDobLoading(false));
    dispatch(setDobModal(false));
  };
  const onError = (): any => {
    dispatch(setDlVerified(false));
    dispatch(setDobLoading(false));
    centeredNotification('Driving License not found');
    form.setFields([
      {
        name: 'drivingLicense',
        value: '',
      }]);
    setIsLoading(false);
    dispatch(setDobModal(false));
  };

  const close = (): void => {
    dispatch(setDobLoading(false));
    dispatch(setDobModal(false));
  };

  return (
    <>
      <Modal visible={true} footer={null} className={'text-left'} centered={true} onCancel={close}>
        <Form form={form}>
          <Col>
            <p className="titleText">Please enter your D.O.B for Driving License verification</p>
          </Col>
          <Row style={{marginLeft: '10%'}}>
            <Col md={22}>
              <Form.Item name="dateOfBirthDrivingLicense" rules={[{ required: true, message: 'Enter you DOB!' }]}>
                <DatePicker style={{ width: '100%' }} placeholder="Enter your DOB" />
              </Form.Item>

            </Col>
          </Row>
          <Col>
            <Space>
              <Button loading={isLoading} className="btn-form-submit centreButton" onClick={verifyDob}>
                Submit
              </Button>
            </Space>
          </Col>
        </Form>
      </Modal>
    </>
  );

};

export default DobIdentityModal;
